import { useContext } from 'react';
import ContentResultsResearch from '@/ContentResultsResearch/ContentResultsResearch';
import HideOnNative from '@/HideOnNative';
import Modals from '@/Modals';
import { NewPriceBanner } from '@/NewPrice';
import DeliveryBannerWrapper from '@/Search/components/DeliveryBannerWrapper';
import { ResultsSection } from '@/SearchResults/ResultsSection';
import BreadCrumbs from '@/SEO/BreadCrumbs';
import StaticContext from '~/contexts/StaticContext';
import NativeError from '~/native/NativeError';
import BackgroundOverlay from './BackgroundOverlay';
import Filters from './Filters';
import { Container, FiltersResultsContainer, Main } from './MainLayout.styles';
import { SearchHeader, SearchTools } from './SearchHeader';
import MenuOptions from './SearchHeader/MenuOptions';
import EVBanner from '../EVBanner/EVBanner';

export default function MainLayout({ initialSeoProps }) {
  const { hasEVBannerUtm } = useContext(StaticContext);

  return (
    <div className="m-auto max-w-[1800px] relative">
      <BackgroundOverlay />
      <NativeError />
      <DeliveryBannerWrapper />
      <Container>
        <FiltersResultsContainer>
          <Filters />
          <Main>
            <SearchHeader />
            <MenuOptions />
            <SearchTools />
            <div className="bg-grey-1 p-16 m:bg-white m:p-0">
              {hasEVBannerUtm ? <EVBanner /> : <NewPriceBanner />}
              <ResultsSection />
            </div>
          </Main>
        </FiltersResultsContainer>
        <HideOnNative>
          <div className="bg-white flex flex-col h-[84px] mt-32 w-100">
            <div className="border-0 border-grey-2 border-solid border-t flex flex-col h-[100%] justify-center w-100">
              <BreadCrumbs />
            </div>
          </div>
        </HideOnNative>
      </Container>
      <Modals />
      <HideOnNative>
        <ContentResultsResearch initialSeoProps={initialSeoProps} />
      </HideOnNative>
    </div>
  );
}
